export enum CopilotPriorityLabel {
    None = "None",
    Low = "Low",
    Normal = "Normal",
    High = "High"
}

export enum CopilotNeedsReplyLabel {
    NeedsReply = "NeedsReply",
    NoReplyNeeded = "NoReplyNeeded"
}

export function getCopilotPriorityLabel(score: number | undefined | null): CopilotPriorityLabel {
    switch (score) {
        case 5:
        case 4:
            return CopilotPriorityLabel.High;
        case 3:
            return CopilotPriorityLabel.Normal;
        case 2:
        case 1:
            return CopilotPriorityLabel.Low;
        default:
            return CopilotPriorityLabel.None;
    }
}
